import { Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UiValidator } from 'src/app/common/field-validation/ui-validator.dto';
import { MyErrorStateMatcher } from 'src/app/common/field-validation/my-error-state-matcher';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DrawOptionInstanceDTO, BetSlipPickedDTO } from '../../../lottomart/model/lottomart-model';

@Component({
  selector: 'app-form-field-shape',
  templateUrl: './shape-form-field.component.html',
  styleUrls: ['../shape.component.scss'],
  standalone: false,
})
export class ShapeFormFieldComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  drawOption: DrawOptionInstanceDTO;

  picked: BetSlipPickedDTO;

  matcher: MyErrorStateMatcher;

  ngOnDestroy() {}

  setRowData(entity: any) {
    this.drawOption = {
      id: entity.id,
      lottoDrawId: entity.lottoDrawId,
      optionType: entity.optionType,
      primaryDraw: entity.primaryDraw,
      minRange: entity.minRange,
      maxRange: entity.maxRange,
      numberOfSelections: entity.numberOfSelections,
      name: entity.name,
      price: entity.price,
      optional: entity.optional,
      minRangeMultiplier: entity.minRangeMultiplier,
      maxRangeMultiplier: entity.maxRangeMultiplier,
      nonSelectedStrokeColor: entity.nonSelectedStrokeColor,
      nonSelectedFillColor: entity.nonSelectedFillColor,
      selectedStrokeColor: entity.selectedStrokeColor,
      selectedFillColor: entity.selectedFillColor,
      selectedTextColor: entity.selectedTextColor,
      selectionPlaceholderFillColor: entity.selectionPlaceholderFillColor,
      selectionPlaceholderStrokeColor: entity.selectionPlaceholderStrokeColor,
      shapeType: entity.shapeType,
    } as DrawOptionInstanceDTO;

    this.picked = {
      id: 1,
      drawOptionId: 1,
      value: 2,
      isNumber: true,
      picked: true,
      inResult: true,
      isJolly: false,
    } as BetSlipPickedDTO;
  }

  clearField(): void {}

  condition(v: UiValidator): boolean {
    return false;
  }

  message(v: UiValidator): string {
    return null;
  }
}
